var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#0B7DE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8998 24.7008C31.8998 24.2037 31.4969 23.8008 30.9998 23.8008C30.5027 23.8008 30.0998 24.2037 30.0998 24.7008V30.1008H24.6998C24.2027 30.1008 23.7998 30.5037 23.7998 31.0008C23.7998 31.4978 24.2027 31.9008 24.6998 31.9008L30.0998 31.9008V37.3008C30.0998 37.7978 30.5027 38.2008 30.9998 38.2008C31.4969 38.2008 31.8998 37.7978 31.8998 37.3008V31.9008H37.2998C37.7969 31.9008 38.1998 31.4978 38.1998 31.0008C38.1998 30.5037 37.7969 30.1008 37.2998 30.1008H31.8998V24.7008Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.f6702024fab0e98c59dea80658e564e8.svg";
export { ForwardRef as ReactComponent };